//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useContext } from 'react';

// === COMPONENTS ===
import { Select as CustomSelect } from 'components/Select';

// === API ===
import {TaskContext} from 'pages/TaskVerification/components/TaskContext/TaskContext';
import {requestPreviousFieldFocus, updateField} from "api/prokey/prokey.websocket";
import {validate} from './validation/index';
import {SUCCESS_CODE} from 'constants/general';

//#endregion

export { validate };

//-----------------------------------------------------------------
export function Doctype( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { field } = props;

  const {
    doctypes,
  } = useContext( TaskContext );

  // const theme    = useTheme();

  const [ content, setContent ] = useState( props.value );

  const is_auto_mode = localStorage.getItem('auto-mode') === 'true';

  field.validationInfo.acceptableValues = doctypes ? Object.values(doctypes[0].options).map( x => x.value ) : [];

  //#endregion
  
  //#region [STYLES]

  //#region [STYLES]
  const pt_style = {
    ...props.style,
    width: '100%',
  }


  //#endregion

  //#region [blue] methods

  //-----------------------------------------------------------------
  function getNumCode() {
    //-----------------------------------------------------------------
    if (!content) return '';

    let numCode = content;
    if (numCode[0] === 'D') numCode = numCode.slice(1);
    if (numCode[0] === 'F') numCode = 'F';
    if (numCode[0] === 'B') numCode = 'B';

    let label = numCode;
    return label;
  }

  //-----------------------------------------------------------------
  function getLabel() {
    //-----------------------------------------------------------------
    // if (is_changing) return value;
    let result = getNumCode();
    const full_list = doctypes.find( x => x.label === 'Full' ).options;
    const option_filter = full_list.find( (x) => x.value.toUpperCase() === result.toUpperCase() );
    const match_found = !!option_filter;

    if (match_found) {
      result = option_filter.label;
    }
    return result;
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onChange( event ) {
    //-----------------------------------------------------------------
    // setIsChanging(true);
    const value = event.target ? event.target.value : event.value;
    if( event.isSubmit ) {
      setContent( value );
      const result = validate( value, field.validationInfo );
      if( result.status === SUCCESS_CODE ) updateField( event.trigger, field.id, field.Name, { Content: result.content } );
    }
  }

  //-----------------------------------------------------------------
  function onKeyDown( event ) {
    //-----------------------------------------------------------------
    try {
      const is_action_prev = event.key === 'Tab' && event.shiftKey ;
      if( is_action_prev ) {
        event.preventDefault();
        event.stopPropagation();
        requestPreviousFieldFocus( props.id );
      }
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <CustomSelect
        name={props.name}
        id={props.id}
        inputStyle={props.style}
        options={doctypes}
        value={getLabel()}
        forceSelected={true}
        innerRef={props.inputRef}
        has_focus={props.has_focus}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={props.onBlur}
        disabled={field.isReadOnly}
      />
    );
  } 

  //#endregion

  return display();
}